import { AnyAction } from 'redux';
import {
  App,
  BasisAdresse,
  Immobilie,
  PhVorbelegungdaten,
  PlzChanged,
} from '@ps20-frontend/frontend-models';
import {
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { PhActions } from '../phActions';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      const immobilie: Immobilie = action.payload.immobilie as Immobilie;

      if (!immobilie || action.payload.appId !== App.PH) {
        return sectionState;
      }

      const risikoort: BasisAdresse = immobilie.risikoort;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case PhActions.PLZ_CHANGED: {
      const actionPayload: PlzChanged = action.payload;
      return {
        plz: actionPayload.plz,
        strasse: '',
        hausnummer: '',
        ort: '',
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: PhVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.PH) {
        return {
          ...sectionState,
          plz: actionPayload.vnAdresse?.plz,
          strasse: actionPayload.vnAdresse?.strasse,
          hausnummer: actionPayload.vnAdresse?.hausnummer,
          ort: actionPayload.vnAdresse?.ort,
        };
      }
      return sectionState;
    }
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.PH_BASISDATEN) {
        return sectionState;
      }
      if (payload.orte?.length === 1) {
        return {
          ...sectionState,
          ort: action.payload.orte[0],
        };
      }
      return sectionState;
    }
    case PhActions.ORT_CHANGED: {
      return { ...sectionState, ort: action.payload.ort };
    }
    case PhActions.STRASSE_CHANGED: {
      return { ...sectionState, strasse: action.payload.strasse };
    }
    case PhActions.HAUSNUMMER_CHANGED: {
      return { ...sectionState, hausnummer: action.payload.hausnummer };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const risikoort: BasisAdresse = action.payload.versicherungsnehmer.adresse;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }

    default:
      return sectionState;
  }
};
